import styled from 'styled-components'

const MODAL_MAX_WIDTH = '550px'

export const ModalSaveProject = styled.section`
  max-width: ${MODAL_MAX_WIDTH};

  @media (min-width: 768px) {
    padding: 5px 15px;
  }

  p:last-of-type {
    margin-bottom: 30px;
  }

  input {
    max-width: calc(0.7 * ${MODAL_MAX_WIDTH});
    margin-bottom: 25px !important;

    &[type='checkbox'] {
      display: none;

      & + label {
        display: block;
        padding-left: 32px;
        margin-bottom: 10px;
        position: relative;
        max-width: calc(0.85 * ${MODAL_MAX_WIDTH});

        @media (hover: hover) {
          &:hover {
            cursor: pointer;
          }
        }

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 22px;
          height: 22px;
          border: 1px solid #1d1d1b;
        }

        a {
          display: inline-block;
          color: inherit;

          .far,
          .fas {
            transform: rotate(45deg);
            margin-left: 4px;
          }
        }
      }

      &:checked {
        & + label {
          &::after {
            content: '';
            position: absolute;
            top: 4px;
            left: 4px;
            width: 16px;
            height: calc(16px / 2);
            border-bottom: 2px solid ${(props) => props.theme.palette.primary.main};
            border-left: 2px solid ${(props) => props.theme.palette.primary.main};
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
          }
        }
      }
    }
  }

  .error-message,
  .success-message {
    display: block;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
  }

  input + .error-message {
    margin-top: -15px;
  }

  .error-message {
    color: ${(props) => props.theme.palette.error.main};
  }

  .success-message {
    color: ${(props) => props.theme.palette.primary.main};

    .far,
    .fas {
      margin-right: 6px;
    }
  }

  button {
    margin: 15px 0;
  }
`
